module.exports = __webpack_public_path__ + "static/media/ios-play.1cdd1b8d.svg";